import Usuario from "./Usuario"
import { Configurations } from "./Configurations";

export class Permissions {

    static checkPermission(permissions, page) {
        const nums = permissions.map(i => i.numero);
        const hasAdmin = nums.some(i => i === 1);

        if (hasAdmin) return true;

        const permissoes = [];
        nums.map(i => this.pagesAccess(i).map(x => permissoes.push(x)));
        return permissoes.some(i => i === page);
    }

    static pagesAccess(numPermissao) {
        switch (numPermissao) {
            case 1: //ATENDIMENTO
                return ['admin'];
            case 2: //ATENDIMENTO
                return ['atendimento', 'pedidos', 'perfil', 'cile'];

            case 3: //LOGISTICA
                return ['logística', 'perfil', 'cile', 'cile-pedidos', 'cile-remessas'];

            case 4: //SUPERVISOR
                return ['atendimento', 'pedidos', 'logística', 'perfil', 'conteúdo', 'relatórios', 'faturamento', 'avisos'];

            case 5: //BS
                return ['perfil', 'conteúdo', 'bs'];

            case 6: //TC
                return ['perfil', 'conteúdo', 'tc'];

            case 7: //RD
                return ['perfil', 'conteúdo', 'rd'];

            case 8: //BM
                return ['perfil', 'conteúdo', 'bm'];

            case 9: //FATURAMENTO
                return ['perfil', 'faturamento'];

            case 10: //VIDEOS
                return ['perfil', 'conteúdo', 'videos']

            case 11: //PODCASTS
                return ['perfil', 'conteúdo', 'podcasts'];

            case 12: //AREAS ESPECIAIS
                return ['perfil', 'conteúdo', 'áreas especiais'];

            case 13: //FRASE DO DIA
                return ['perfil', 'conteúdo', 'frase do dia'];

            case 14: //SUPERVISOR DE CONTEÚDO
                return ['perfil', 'conteúdo'];

            case 15: //SUPERVISOR DE FINANCEIRO
                return ['perfil', 'pedidos', 'faturamento', 'relatórios'];

            case 16: //SUPERVISOR DE ATENDIMENTO
                return ['perfil', 'logística', 'pedidos', 'atendimento', 'relatórios', 'avisos', 'cile'];

            case 17: //Coordenadores de Periódicos
                return ['perfil', 'coordenadores de periódicos'];

            case 18: //Relatorios
                return ['perfil', 'relatórios'];

            case 19: //Avisos
                return ['perfil', 'avisos'];

            case 20: //Destaques
                return ['perfil', 'conteúdo'];

            case 21: //Publicidade
                return ['perfil', 'conteúdo'];

            case 22: //Aprovação de edição
                return ['perfil', 'conteúdo'];

            case 23: //KPIs
                return ['perfil', 'kpis'];

            case 24: //Estatística
                return ['perfil', 'conteúdo', 'bs', 'tc', 'rd'];

            case 26: //CILE Relatórios
                return ['perfil', 'cile', 'cile-relatorios'];

            case 28: //BJ
                return ['perfil', 'conteúdo', 'bj'];

            case 30: //UNIFICAÇÃO
                return ['cadastros'];

            case 34: //CILE Conteúdo
                return ['perfil', 'cile', 'cile-conteudo'];

            case 37: //CILE Kit
                return ['perfil', 'cile', 'cile-kits'];

            case 38: //CILE Produto
                return ['perfil', 'cile', 'cile-produto'];

            case 41: //Playlists
                return ['perfil', 'conteúdo', 'playlists'];
            
            case 42: //CILE Epub
                return ['perfil', 'cile', 'cile-epub'];
            
            case 43: //CILE Assinaturas
                return ['perfil', 'cile', 'cile-assinaturas']; 

            default: //ADMIN (=1)
                return ['perfil'];


        }
    }

    //enums
    static get ADMIN() { return 1 };
    static get ATENDIMENTO() { return 2 };
    static get LOGISTICA() { return 3 };
    static get SUPERVISOR() { return 4 };
    static get EDITORBS() { return 5 };
    static get EDITORTC() { return 6 };
    static get EDITORRD() { return 7 };
    static get EDITORBM() { return 8 };
    static get FATURAMENTO() { return 9 };
    static get VIDEOS() { return 10 };
    static get PODCASTS() { return 11 };
    static get AREASESPECIAIS() { return 12 };
    static get FRASEDODIA() { return 13 };
    static get SUPCONTEUDO() { return 14 };
    static get SUPFINANCEIRO() { return 15 };
    static get SUPATENDIMENTO() { return 16 };
    static get COORDPERIODICO() { return 17 };
    static get RELATORIOS() { return 18 };
    static get AVISOS() { return 19 };
    static get DESTAQUES() { return 20 };
    static get PUBLICIDADE() { return 21 };
    static get KPIS() { return 23 };
    static get ESTATISTICA() { return 24 };
    static get CILERELATORIO() { return 26 };
    static get EDITORBJ() { return 28 };
    static get CILECONTEUDO() { return 34 };
    static get CILEKITS() { return 37 };
    static get CILEPRODUTO() { return 38 };
    static get PLAYLISTS() { return 41 };
    static get CILEEPUB() { return 42 };
    static get CILEASSINATURAS() { return 43 };

    static hasAuthorization(roles) {
        const confis = new Configurations();
        const userData = Usuario.getDadosUsuario(window.localStorage.getItem(confis.tokenKey));

        if (userData === undefined) return false;

        const userPermissions = userData.permissoes;
        if (userPermissions === undefined) return false;
        return roles.some(role => userPermissions.some(permission => permission.numero === role));
    }

}